
const getInstallmentPrice = ({ price }) => {
  let installment_months = 12;
  if (price >= 1500 && price <= 2499) {
    installment_months = 18;
  } else if (price > 2500) {
    installment_months = 18; // redundant logic
  }
  const installment_price = Math.round(price / installment_months);
  const installment_price_text = `From $${installment_price.toLocaleString()}/mo for ${installment_months} months at 0% APR.`;
  return { installment_price, installment_price_text };
};

export default getInstallmentPrice;
